import teamRequestModalApproveComponent from './teamRequestModalApprove.component';

let teamRequestModalApproveModule = angular.module('vacations-absences.teamRequestModalApprove', [])

.component('teamRequestModalApprove', teamRequestModalApproveComponent)

.name;

export default teamRequestModalApproveModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestModalApprove/teamRequestModalApprove.js